angular.module('impactx.imageUpload', ['ngImgCrop']);